"use client";

import { strings } from "@perceptron/constants";
import { Icon } from "@perceptron/ui/components/icon";
import { InputGroup, InputGroupAddon, InputGroupButton, InputGroupInput } from "@perceptron/ui/components/inputGroup";

import { useDetectStore } from "@demo/store/detect";

const CategoryInput = () => {
  // The draft lives in the store (not local state) so `runDetect` can commit
  // whatever is still typed when Run is hit.
  const value = useDetectStore((state) => state.pendingCategory);
  const setPendingCategory = useDetectStore((state) => state.setPendingCategory);
  const addCategory = useDetectStore((state) => state.addCategory);

  const handleAdd = () => {
    const trimmed = value.trim();
    if (!trimmed) return;
    addCategory(trimmed);
    setPendingCategory("");
  };

  return (
    <InputGroup className="h-auto shrink-0 rounded-md border-background-alt-1 bg-background-alt-2 px-4 py-1">
      <InputGroupInput
        className="p-0 text-foreground-primary label-2 placeholder:italic placeholder:text-foreground-disabled"
        placeholder={strings.detect.categoryPlaceholder}
        value={value}
        onChange={(e) => setPendingCategory(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            handleAdd();
          }
        }}
      />
      <InputGroupAddon align="inline-end" className="pr-0">
        <InputGroupButton
          aria-label={strings.detect.addCategoryAriaLabel}
          className="rounded-full"
          disabled={!value.trim()}
          size="icon-sm"
          onClick={handleAdd}
        >
          <Icon className="size-4 text-white" name="plus" />
        </InputGroupButton>
      </InputGroupAddon>
    </InputGroup>
  );
};

export default CategoryInput;
